import React, { Component } from "react";
import HeaderNavBar from "../HeaderNavBar/HeaderNavBar";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import Footer from "../Footerpage/Footer";
import TranslationFile from "../Translation/Translation_corp.json";
import CMSTranslationFile from "../AboutUs/RBLPricePolicy__Translation_Corp.json";
import "./AboutUs.css";

let userSelectedLanguage;

class PricePolicy extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    window.scrollTo(0, 0);
  }
  callback = () => {
    this.setState({
      reRender: true,
    });
  };
  render() {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    return (
      <div>
        <HeaderNavBar isCorpPortal={true} callBack={this.callback} />
        <div className="ID_About-Us">
          <br></br>
          <br></br>
          <div class="cor-product" id="price-policy-div">
            <div id="cor-product-section">
              <h2 className="cor-product-h2">
                {CMSTranslationFile.PricePolicy_Title[userSelectedLanguage]}
              </h2>
              <br></br>
              <section>
                {CMSTranslationFile.PricePolicy_Text1[userSelectedLanguage]}
              </section>
            </div>
          </div>
        </div>
        <ScrolltoTop />
        <Footer />
      </div>
    );
  }
}
export default PricePolicy;
